import React from 'react'

const EyeIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="eyeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 180, 255, 1)" />
          <stop offset="100%" stopColor="rgba(60, 140, 220, 1)" />
        </linearGradient>
        <filter id="eyeGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Eye outline */}
      <path 
        d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"
        fill="url(#eyeGradient)"
        filter="url(#eyeGlow)"
      />
      
      {/* Iris */}
      <circle 
        cx="12" 
        cy="12" 
        r="3.5" 
        fill="rgba(40, 80, 140, 0.9)"
      />
      
      {/* Pupil */}
      <circle 
        cx="12" 
        cy="12" 
        r="2" 
        fill="rgba(10, 20, 40, 1)"
      />
      
      {/* Highlight */}
      <circle 
        cx="13" 
        cy="11" 
        r="1" 
        fill="rgba(255, 255, 255, 0.8)"
      />
    </svg>
  )
}

export default EyeIcon
